import { SetURLSearchParams, useSearchParams } from "react-router-dom";

import type { UnlockTabParams } from "@/@types/unlock-request";
import { DEFAULT_PAGE } from "@/constants/pagination";
import { UNLOCK_TAB_PARAMS } from "@/constants/unlock-request";
import { applyToSearchParams, readInt } from "@/utils/search-params";
import { readUnlockPerPage } from "@/utils/unlock-request";

export function useUnlockTabParams(): UnlockTabParams {
  const [searchParams, setSearchParams]: [URLSearchParams, SetURLSearchParams] =
    useSearchParams();

  const search: string = searchParams.get(UNLOCK_TAB_PARAMS.SEARCH) ?? "";

  const update = (updates: Readonly<Record<string, string | null>>): void => {
    setSearchParams(applyToSearchParams(searchParams, updates), {
      replace: true,
    });
  };

  return {
    page: readInt(searchParams.get(UNLOCK_TAB_PARAMS.PAGE), DEFAULT_PAGE),
    perPage: readUnlockPerPage(searchParams.get(UNLOCK_TAB_PARAMS.PER_PAGE)),
    search,
    goToPage: (page: number): void => update({ [UNLOCK_TAB_PARAMS.PAGE]: String(page) }),
    changePerPage: (perPage: number): void =>
      update({
        [UNLOCK_TAB_PARAMS.PER_PAGE]: String(perPage),
        [UNLOCK_TAB_PARAMS.PAGE]: null,
      }),
    changeSearch: (next: string): void => {
      if (next === search) return;
      update({ [UNLOCK_TAB_PARAMS.SEARCH]: next, [UNLOCK_TAB_PARAMS.PAGE]: null });
    },
  };
}
